import React from 'react';

import FreeTrialLeft from './free_trial_left';
import FreeTrialCenter from './free_trial_center';

interface FreeTrialProps {
  block: {
    _template: string;
    css_class_name: string;
    title: string;
    text: string;
    text_position_class: string;
    cta_field: {
      cta_link: string;
      cta_text: string;
    };
  };
}

export default function FreeTrial({ block }: FreeTrialProps) {
  return (
    <section
      className={`block ${block._template} ${block.css_class_name} ${block.text_position_class}`}
    >
      <div className='container'>
        {block.text_position_class === 'pos-left' ? (
          <FreeTrialLeft block={block} />
        ) : (
          <FreeTrialCenter block={block} />
        )}
      </div>
    </section>
  );
}
